export default __webpack_public_path__ + "static/media/eth.a65aaf92.svg";